import api from './services/mkm.api.js'

const resource = '/kukudufoerderung'

export default {
    senden(payload) {
        return api.post(`${resource}`, payload)
    }
}